module.exports = __webpack_public_path__ + "static/58-48776db2d00720f1c28dde54331f93d1.png";